module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', [_c('v-card', [_c('v-card-title', {
    staticClass: "subheading"
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.requests.configure.loading,
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1), _vm._v("\n      Configure Mailchimp\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": "https://mailchimp.com",
      "color": "success",
      "target": "_blank",
      "small": ""
    }
  }, [_vm._v("\n        Get a Mailchimp account\n        "), _c('v-icon', {
    staticClass: "pl-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "info",
      "outline": "",
      "outlined": ""
    }
  }, [_vm._v("\n        You can get your mailchimp API Key from:"), _c('br'), _vm._v(" "), _c('code', [_vm._v("Click on your name (top right) -> profile -> extras -> API keys")]), _c('br'), _vm._v("\n        Or click this link: "), _c('a', {
    attrs: {
      "href": "https://admin.mailchimp.com/account/api/",
      "target": "_blank"
    }
  }, [_vm._v("\n        https://admin.mailchimp.com/account/api/\n        "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1), _c('br'), _vm._v("\n        If you don't already have a key, you will need to create one\n      ")]), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Mailchimp API key"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.configure.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.token),
      callback: function($$v) {
        _vm.token = $$v
      },
      expression: "token"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.token,
      "block": "",
      "loading": _vm.requests.configure.loading
    },
    on: {
      "click": _vm.configure
    }
  }, [_vm._v("Save token")])], 1)], 1), _vm._v(" "), (_vm.savedToken) ? _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.lists,
      "loading": _vm.requests.lists.loading,
      "item-text": "name",
      "item-value": "id",
      "prepend-icon": "replay",
      "label": "Choose a list to connect to AppointmentGuru"
    },
    on: {
      "click:prepend": _vm.getLists
    },
    model: {
      value: (_vm.listId),
      callback: function($$v) {
        _vm.listId = $$v
      },
      expression: "listId"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.requests.list.loading,
      "disabled": !_vm.listId,
      "block": ""
    },
    on: {
      "click": _vm.setList
    }
  }, [_vm._v("Set list")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.savedToken && _vm.savedListId) ? _c('v-card', {
    staticClass: "mt-3"
  }, [_c('v-card-title', [_vm._v("\n      Sync contacts from AppointmentGuru to the\n      "), _c('strong', {
    staticClass: "mx-1"
  }, [_vm._v(_vm._s(_vm.savedList.name))]), _vm._v("\n      mailing list\n    ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-dialog', {
    ref: "dialog",
    attrs: {
      "width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "clearable": "",
            "persistent-hint": "",
            "label": "Only sync recent contacts",
            "hint": "Only sync contacts with appointments since this date. Leave blank to sync all contacts",
            "readonly": ""
          },
          model: {
            value: (_vm.syncSince),
            callback: function($$v) {
              _vm.syncSince = $$v
            },
            expression: "syncSince"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }], null, false, 1404622941),
    model: {
      value: (_vm.datepicker),
      callback: function($$v) {
        _vm.datepicker = $$v
      },
      expression: "datepicker"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    model: {
      value: (_vm.syncSince),
      callback: function($$v) {
        _vm.syncSince = $$v
      },
      expression: "syncSince"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.sync.loading,
      "color": "primary",
      "block": ""
    },
    on: {
      "click": _vm.performSync
    }
  }, [_vm._v("Start sync")])], 1), _vm._v(" "), (_vm.syncBatchId) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-4 overline"
  }, [_vm._v("\n            Results\n            "), _c('v-spacer'), _vm._v(" "), (_vm.syncStatus.status === "finished") ? _c('v-chip', {
    attrs: {
      "small": "",
      "dark": "",
      "color": "success"
    }
  }, [_vm._v(_vm._s(_vm.syncStatus.status))]) : _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 20,
      "width": 2,
      "indeterminate": ""
    }
  })], 1), _vm._v("\n              " + _vm._s(_vm.syncStatus.status) + "\n            ")], 1)], 1), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote"
  }, [_c('div', [_c('strong', [_vm._v("Total imports")]), _vm._v(" " + _vm._s(_vm.syncStatus.total_operations))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Completed imports")]), _vm._v(" " + _vm._s(_vm.syncStatus.finished_operations))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Errored or skipped")]), _vm._v(" " + _vm._s(_vm.syncStatus.errored_operations))]), _vm._v(" "), (_vm.syncStatus.response_body_url) ? _c('div', [_c('a', {
    attrs: {
      "href": _vm.syncStatus.response_body_url,
      "target": "_blank"
    }
  }, [_vm._v("Download results")])]) : _vm._e()]), _vm._v(" "), _c('v-btn', {
    staticClass: "pr-3",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "small": "",
      "flat": "",
      "pull-right": ""
    },
    on: {
      "click": _vm.getSyncStatus
    }
  }, [_vm._v("Refresh status")])], 1) : _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "outline": "",
      "outlined": "",
      "text": "",
      "type": "warning"
    }
  }, [_c('strong', [_vm._v("Before you sync your mailing list")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("\n                If relevant: make sure any automations in Mailchimp are disabled (assuming you don't want to run them when new contacts are added)\n              ")]), _vm._v(" "), _c('li', [_vm._v("\n                If you have a very large contact list in AppointmentGuru, consider limiting your\n                sync to only more recently active users\n              ")]), _vm._v(" "), _c('li', [_vm._v("\n                This sync will match users on e-mail address:\n                "), _c('ol', [_c('li', [_vm._v("If they exist, where relevant, their details will be updated - but they will not be duplicated")]), _vm._v(" "), _c('li', [_vm._v("If the email does not exist, a new member will be added in Mailchimp")]), _vm._v(" "), _c('li', [_vm._v("We also add some merge tags with appointment information (last appointment, next appointment, number of appointments etc.)\n                    - you can use this to segment members in mailchimp")])])])])])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.savedToken && _vm.savedListId) ? _c('v-card', {
    staticClass: "mt-3"
  }, [_c('v-card-title', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.savedList.name) + "\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": _vm.savedList.subscribe_url_long,
      "target": "_blank",
      "small": "",
      "flat": "",
      "text": ""
    }
  }, [_vm._v("\n        Subscription URL\n        "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), (_vm.openInMailchimp) ? _c('v-btn', {
    attrs: {
      "href": _vm.openInMailchimp,
      "target": "_blank",
      "small": "",
      "flat": "",
      "text": ""
    }
  }, [_vm._v("\n        Open in Mailchimp\n        "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    }
  }, [_vm._v("Sync")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.savedList.stats) ? _c('v-card-text', [_c('v-subheader', [_vm._v("Stats")]), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.savedList.stats), function(value, key) {
    return _c('v-list-tile', {
      key: key
    }, [_c('v-list-tile-content', [(key) ? _c('v-list-tile-title', [_vm._v(_vm._s(key.replace('_', ' ')) + "\n            ")]) : _vm._e(), _vm._v(" "), (key === "last_sub_date") ? _c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(value)
      }
    }) : _vm._e(), _vm._v(" "), (key === "last_unsub_date") ? _c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(value)
      }
    }) : _vm._e()], 1), _vm._v(" "), (key && !key.endsWith("_date")) ? _c('v-list-tile-avatar', [_vm._v("\n              " + _vm._s(value || '-') + "\n          ")]) : _vm._e()], 1)
  }), 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.savedToken) ? _c('v-card', {
    staticClass: "mt-3"
  }, [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n      Danger Zone\n    ")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": 290
    },
    model: {
      value: (_vm.showuninstall),
      callback: function($$v) {
        _vm.showuninstall = $$v
      },
      expression: "showuninstall"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n          Are you sure you want to unintsall the Mailchimp integration?\n        ")]), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showuninstall = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.delete.loading,
      "color": "error"
    },
    on: {
      "click": _vm.uninstall
    }
  }, [_vm._v("\n            Uninstall Mailchimp\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "loading": _vm.requests.delete.loading,
      "color": "error"
    },
    on: {
      "click": function($event) {
        _vm.showuninstall = true
      }
    }
  }, [_vm._v("\n        Uninstall integration")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f620f66","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/Mailchimp/index.vue
// module id = 1663
// module chunks = 8